// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Q0Qg","largestCol":"styles_largestCol__Kv2Ie","smallestCol":"styles_smallestCol__2OxNr"};